module.exports = __webpack_public_path__ + "h5/img/kefu.1e7ed14f.png";